import React, { Component } from 'react';
import { connect } from "react-redux";

const WIDTH = 36;
const LEFT_SPACE = 58;
const TOP_SPACE = 30;
const DEFAULT_HEIGHT = 24;

function PianoRollSelection(props) {
    if (props.selection === undefined ||
        (props.selection.numNotes === 1 && props.selection.numSteps === 1)) {
        return (
            <div></div>
        );
    }

    let scaledWidth = props.xScale * WIDTH;
    let rowHeight = DEFAULT_HEIGHT * props.scale;

    let firstNote = props.notes[0].getTranspose();

    let y = (firstNote - props.selection.transpose) * rowHeight;
    let x = (props.selection.stepNumber) * scaledWidth;
    let height = (props.selection.numNotes) * rowHeight;
    let width = (props.selection.numSteps) * scaledWidth;

    let style = {
        left: x,
        top: y + TOP_SPACE,
        height: height,
        width: width,
    };
    return (
        <div style={style} className="piano-roll-selection">
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        selection: state.keyboard.pianoRollSelection,
        notes: state.keyboard.notes,
    }
};


export default connect(mapStateToProps, null)(PianoRollSelection);
